// Make sure these constants match the ones declared in index.scss->:root

export const PRIMARY = '#1976d2';
export const PRIMARY_PALE = '#E8F1FA'
export const MATTE_GRAY = '#EEEEEE';
export const SECONDARY_GRAY = '#767676';
